import { Link, useLocation } from "react-router-dom";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";

const menuItems = [
  {
    title: "Orders",
    link: "/orders",
  },
  {
    title: "My Stock",
    link: "/my-stock",
  },
  {
    title: "Details",
    link: "/details",
  },
  {
    title: "Making Charges",
    link: "/making-charges",
  },
  {
    title: "My Store",
    link: "/my-store",
  },
  {
    title: "Store Links",
    link: "/store-links/:",
  },
];

const DashboardSidebar = () => {
  const location = useLocation();

  const menuItemStyles = {
    root: {
      fontSize: "14px",
      fontWeight: 400,
    },
  };

  return (
    <Sidebar
      rootStyles={{ color: "#607489" }}
      width={"230px"}
      className="dashboard_sidebar"
    >
      <Menu menuItemStyles={menuItemStyles} className="sidebar_menu_con">
        {menuItems.map((menu) => (
          <MenuItem
            key={menu.link}
            component={<Link to={menu.link} />}
            active={location.pathname === menu.link}
          >
            {menu.title}
          </MenuItem>
        ))}
      </Menu>
    </Sidebar>
  );
};

export default DashboardSidebar;
